// extracted by mini-css-extract-plugin
module.exports = {"dropMenu":"drop-menu_dropMenu__u9Z93"};